 
<app-header></app-header>
<app-sidebar></app-sidebar>

<app-container></app-container>


<app-footer></app-footer>